import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import { get_excel} from '../redux/actions';
import './AdminPage.css';

import UsersList from './UsersList';


function AdminPage(){
    
    const dispatch = useDispatch();
    const [showing, setShowing] = useState('users')
    // const userData = useSelector(state => state.userStatus.profile)
    // const avistamentos = useSelector(state => state.avistamentosUser.avistamentos)
    // const [observacoes, setObservacoes] = useState(0)

    // useEffect(() => {
        

    //     const summer = () => {
    //         if(avistamentos.length !==0){
    //             return avistamentos[0].properties.id_user.n_animais + avistamentos[0].properties.id_user.n_ninhos + avistamentos[0].properties.id_user.n_ataques
    //         }
         
     
    //         return 0
    //     }
    //     setObservacoes(summer())
        
    // }, [avistamentos]);
    if(window.innerWidth<=1024) return <div>A área de administração está otimizada para utilização em computador desktop ou laptop.</div>
    return(
        
        <div className='page-body'>
            <div
                className='options-bar' 
            >
                
                    
                 <div style={showing==='users'?{fontWeight:'bold'}:{cursor:'pointer'}} onClick={() => setShowing('users')}>Gerir utilizadores</div>
                 <div style={showing==='download'?{fontWeight:'bold'}:{cursor:'pointer'}} onClick={() => setShowing('download')}>Descarregar avistamentos</div>  
            </div>
            
    
                {showing==='download'?<div onClick={() => dispatch(get_excel())} style={{cursor:'pointer'}}>Descarregar todos os avistamentos</div>:null}
                {showing==='users'?<UsersList />:null}
                
                {/* <ListaAvistamentos tipo = 'utilizador'/>    */}

        </div>
    )
   
    
    

    
}

export default AdminPage;